var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-10"},_vm._l((_vm.obj),function(item,index){return _c('div',{key:index},[_c('foldout',{attrs:{"obj":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }